import React from 'react';
import { Clock } from 'lucide-react';

export function LeadActivityLog({ activities }) {
  return (
    <div className="border border-slate-200 rounded-sm bg-white h-fit">
      <div className="p-4 border-b border-slate-200 flex items-center gap-2">
        <Clock className="w-4 h-4 text-slate-400" />
        <h2 className="font-heading font-semibold text-slate-900 text-sm">Activity Log</h2>
      </div>
      <div className="p-4">
        {activities?.length > 0 ? (
          <div className="space-y-4">
            {activities.map((act, i) => (
              <div key={`${act.timestamp}-${act.action}`} className="relative pl-5" data-testid={`activity-item-${i}`}>
                <div className="absolute left-0 top-1.5 w-2 h-2 rounded-full bg-[#0047AB]" />
                {i < activities.length - 1 && <div className="absolute left-[3px] top-4 w-0.5 h-full bg-slate-200" />}
                <p className="text-sm text-slate-700">{act.details}</p>
                <p className="text-xs text-slate-400 mt-0.5">{act.user_name} &middot; {new Date(act.timestamp).toLocaleString()}</p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-slate-400 text-center py-6">No activity yet</p>
        )}
      </div>
    </div>
  );
}
